import { render, staticRenderFns } from "./app-spacing.vue?vue&type=template&id=8360c5ee&scoped=true&"
import script from "./app-spacing.vue?vue&type=script&lang=js&"
export * from "./app-spacing.vue?vue&type=script&lang=js&"
import style0 from "./app-spacing.vue?vue&type=style&index=0&id=8360c5ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8360c5ee",
  null
  
)

export default component.exports